import vidFleetComponent from 'Modules/.common/components/VidFleetVideo/lan/en';
import infoBubbleComponent from 'Modules/.common/components/InfoBubble/lan/en';
import dtcComponent from 'Modules/.common/components/Dtc/lan/en';
import sharedMediaComponent from 'Modules/.common/components/SharedMedia/lan/en';
import accountInformationComponent from 'Modules/.common/components/AccountInformation/lan/en';
import smartWitnessComponent from 'Modules/.common/components/SmartWitnessVideo/lan/en';
import mapIconPickerComponent from 'Modules/.common/components/IconPicker/lan/en';
import troubleshootDevice from 'Modules/.common/components/TroubleshootDevice/lan/en';
import cameraSetup from 'Modules/.common/components/CameraSetup/lan/en';
import warnings from 'Modules/.common/components/Warnings/lan/en';
import videoAssignDriver from 'Modules/.common/components/VideoAssignDriver/lan/en';
import video from 'Modules/.common/components/Video/lan/en';
import transactionsSummary from 'Modules/.common/components/TransactionsSummary/lan/en';
import filterAvatars from 'Modules/.common/components/FilterAvatars/lan/en';
import driverPerformance from 'Modules/driverPerformance/.globals/lan/en';
import evirPx from 'Modules/evirPx/.globals/lan/en';
import lightMetricsVideo from 'Modules/.common/components/LightMetricsVideo/lan/en';
import mitacVideo from 'Modules/.common/components/MitacVideo/lan/en';
import entityPickerComponent from 'Modules/.common/components/EntityPicker/lan/en';
import entityUnitDriverSelectorComponent from 'Modules/.common/components/EntityUnitDriverSelector/lan/en';
import entityTagViewerComponent from 'Modules/.common/components/EntityTagViewer/lan/en';
import oemDataModalComponent from 'Modules/.common/components/OemDataModal/lan/en';
import oemRemoteCommandsComponent from 'Modules/.common/components/OemDataModal/remoteCommands/lan/en';
import requestVideoComponent from 'Modules/.common/components/RequestVideo/lan/en';

let locales = {}

locales = {
  exportMessageSuccess: 'The export has been generated successfully.',
  exportMessageFailed: 'Sorry, a problem occurred during the export generation.',
  exportMessageFailedNoData: 'No information found.',
  ...vidFleetComponent,
  ...infoBubbleComponent,
  ...dtcComponent,
  ...sharedMediaComponent,
  ...accountInformationComponent,
  ...smartWitnessComponent,
  ...mapIconPickerComponent,
  ...troubleshootDevice,
  ...warnings,
  ...videoAssignDriver,
  ...cameraSetup,
  ...video,
  ...transactionsSummary,
  ...filterAvatars,
  ...driverPerformance,
  ...evirPx,
  ...lightMetricsVideo,
  ...mitacVideo,
  ...entityPickerComponent,
  ...entityUnitDriverSelectorComponent,
  ...entityTagViewerComponent,
  ...oemDataModalComponent,
  ...oemRemoteCommandsComponent,
  ...requestVideoComponent
};

export default locales;
